import { AlertStatus, Spinner } from '@chakra-ui/react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export type StatusVariant =
  | 'info'
  | 'success'
  | 'warning'
  | 'error'
  | 'loading';

const STATUSES = {
  info: { icon: InfoOutlinedIcon, colorScheme: 'blue', textColor: 'navy' },
  warning: {
    icon: ErrorOutlineOutlinedIcon,
    colorScheme: 'orange',
    textColor: 'orange',
  },
  success: {
    icon: CheckCircleOutlineIcon,
    colorScheme: 'green',
    textColor: 'green',
  },
  error: {
    icon: ErrorOutlineOutlinedIcon,
    colorScheme: 'red',
    textColor: 'maroon',
  },
  loading: { icon: Spinner, colorScheme: 'blue', textColor: 'navy' },
};

export function getStatusIcon(val: StatusVariant | AlertStatus) {
  return STATUSES[val as StatusVariant].icon;
}

export function getStatusColorScheme(status: StatusVariant | AlertStatus) {
  return STATUSES[status as StatusVariant].colorScheme;
}

export function getTextColor(status: StatusVariant | AlertStatus) {
  return STATUSES[status as StatusVariant].textColor;
}
